/*
 * #023 オプション選択突破阻止（ステップ1）
 * Globo Product Options の対象商品は、一覧・特集などから直接カートに入れず商品ページへ送る。
 * 条件は Globo PO のオプションセット（1304661 / 1335435 / 1395898）の自動条件と同じにしている。
 * Globo 側の条件を変えたら RULES も合わせて変えること。
 */
(function () {
  'use strict';

  var RULES = [
    { all: ['ノートパソコン', 'R∞PCシリーズ'], none: [] },
    { all: ['デスクトップパソコン', 'R∞PCシリーズ'], none: [] },
    { all: ['中古アウトレット'], none: ['Apple'] }
  ];
  var LABEL = 'オプションを選んで購入';
  var CACHE_KEY = 'og023_tags_v1';

  var tagCache = {};
  try { tagCache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) {}
  var pending = {};

  function needsOptions(tags) {
    return RULES.some(function (r) {
      return r.all.every(function (t) { return tags.indexOf(t) !== -1; }) &&
        r.none.every(function (t) { return tags.indexOf(t) === -1; });
    });
  }

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function currentProductHandle() {
    return handleFromHref(location.pathname);
  }

  function getTags(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    if (pending[handle]) return pending[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    pending[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = p.tags || [];
        tagCache[handle] = tags;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(tagCache)); } catch (e) {}
        return tags;
      })
      .catch(function () { return []; });
    return pending[handle];
  }

  // カート追加フォーム（またはクイック追加ボタン）が属する商品のURLを探す
  function productUrlFor(el) {
    var card = el.closest('.spf-product-card, .card-wrapper, .product-card-wrapper, li, .grid__item, product-info, .product');
    var a = card && card.querySelector('a[href*="/products/"]');
    if (a) return a.getAttribute('href').split('?')[0].split('#')[0];
    // PageFly の ProductBox は商品リンクを持たないので、商品IDから PageFly の商品データを引く
    var pfBox = el.closest('[data-pf-type="ProductBox"], [data-product-id]');
    var pidInput = el.querySelector && el.querySelector('input[name="product-id"]');
    var pid = (pidInput && pidInput.value) || (pfBox && pfBox.getAttribute('data-product-id'));
    var pf = pid && window.__pageflyProducts && window.__pageflyProducts[pid];
    if (!pf || !pf.handle) return null;
    if (pf.tags && !tagCache[pf.handle]) tagCache[pf.handle] = pf.tags;
    return '/products/' + pf.handle;
  }

  // 商品ページ本体のフォーム（Globo PO が入っている）は対象外
  function isMainProductForm(form, handle) {
    if (form.querySelector('[class*="gpo"]')) return true;
    return handle && handle === currentProductHandle() && !form.closest('.spf-product-card, .card-wrapper');
  }

  // フォーム内のカート追加ボタン（PageFly は type="button" の ProductATC）
  var ATC_SELECTOR = '[type="submit"], button:not([type]), [data-pf-type^="ProductATC"], button[name="add"]';

  function guardTarget(el) {
    var form = el.closest('form[action*="/cart/add"]');
    var quick = !form && el.closest('.quick-add__submit, modal-opener[data-modal*="QuickAdd"] button');
    if (!form && !quick) return null;
    var url = productUrlFor(form || quick);
    var handle = handleFromHref(url);
    if (!handle) return null;
    if (form && isMainProductForm(form, handle)) return null;
    return { form: form, button: form ? form.querySelector(ATC_SELECTOR) : quick, url: url, handle: handle };
  }

  var guardedButtons = [];

  function applyLabel(btn) {
    if (btn.disabled) return; // 売り切れ表示はそのまま
    var label = btn.querySelector('span:not(.loading__spinner):not(.hidden)') || btn;
    if (label.textContent.trim() !== LABEL) label.textContent = LABEL;
    btn.setAttribute('aria-label', LABEL);
  }

  function relabel(t) {
    if (!t.button || t.button.dataset.og023) return;
    t.button.dataset.og023 = '1';
    guardedButtons.push(t.button);
    applyLabel(t.button);
  }

  // PageFly など、描画後にボタン文言を書き戻すアプリ対策（各ボタン5回まで）
  function reapplyLabels() {
    guardedButtons.forEach(function (btn) {
      var n = +(btn.dataset.og023Fix || 0);
      if (n >= 5 || btn.disabled || btn.textContent.trim() === LABEL) return;
      btn.dataset.og023Fix = n + 1;
      applyLabel(btn);
    });
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(
      'form[action*="/cart/add"], .quick-add__submit'
    );
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.dataset.og023Scanned) return;
      n.dataset.og023Scanned = '1';
      var t = guardTarget(n);
      if (!t) return;
      getTags(t.handle).then(function (tags) {
        if (needsOptions(tags)) {
          if (t.form) {
            t.form.dataset.og023Guard = '1';
            // 特集商品セクションなどの即時購入（Shop Pay 等）はカートを通らないので隠す
            Array.prototype.forEach.call(t.form.querySelectorAll('.shopify-payment-button'), function (p) {
              p.style.display = 'none';
            });
          }
          relabel(t);
        }
      });
    });
  }

  function intercept(ev) {
    var t = guardTarget(ev.target);
    if (!t) return;
    var known = tagCache[t.handle];
    if (known && !needsOptions(known)) return;
    // 対象商品、またはタグ未取得：いったん止めて判定する
    ev.preventDefault();
    ev.stopImmediatePropagation();
    getTags(t.handle).then(function (tags) {
      if (needsOptions(tags)) {
        location.href = t.url;
      } else {
        // 対象外の商品：元のボタン操作をそのまま通す
        if (t.form) t.form.dataset.og023Pass = '1';
        else if (t.button) t.button.dataset.og023Pass = '1';
        if (t.button) t.button.click();
        else if (t.form) t.form.submit();
      }
    });
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (form.dataset && form.dataset.og023Pass) { delete form.dataset.og023Pass; return; }
    intercept(ev);
  }, true);

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('button, input[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (form && form.dataset.og023Pass) return;
    if (!form && btn.dataset.og023Pass) { delete btn.dataset.og023Pass; return; }
    if (form && btn.matches(ATC_SELECTOR)) intercept({ target: btn, preventDefault: ev.preventDefault.bind(ev), stopImmediatePropagation: ev.stopImmediatePropagation.bind(ev) });
    else if (!form && btn.closest('.quick-add__submit, modal-opener[data-modal*="QuickAdd"]')) intercept({ target: btn, preventDefault: ev.preventDefault.bind(ev), stopImmediatePropagation: ev.stopImmediatePropagation.bind(ev) });
  }, true);

  function start() {
    scan(document);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(document); reapplyLabels(); }, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
